import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Global} from "../global";

@Component({
  selector: 'app-pdf-fatura',
  templateUrl: './pdf-fatura.component.html'
})
export class PdfFaturaComponent {

  url = '';

  alturaTela;

  constructor(
    public global: Global,
    private route: ActivatedRoute
  ) {

    route.params.subscribe(params => {
      this.url = global.dominio_site + '/pub/cron/fatura/' + params['id_fatura'] + '/pdf';
    });

    this.alturaTela = window.screen.availHeight - 250;
  }

}



// WEBPACK FOOTER //
// ./src/app/faturas/pdf-fatura.component.ts